import React from 'react';
import { Box } from '@mui/material';

const ConfidenceBadge = ({ score }) => {
  if (score === null || score === undefined) return null;

  const numericScore = parseFloat(score);
  
  // Determine color based on thresholds: 100% Green, 66% Amber, 33% Red
  let color, bgColor, borderColor;
  
  if (numericScore >= 100) {
    color = '#059669'; // Emerald green
    bgColor = '#f0fdf4'; // Very light green
    borderColor = '#86efac';
  } else if (numericScore >= 66) {
    color = '#d97706'; // Amber
    bgColor = '#fffbeb'; // Very light amber
    borderColor = '#fde68a';
  } else {
    color = '#dc2626'; // Red
    bgColor = '#fef2f2'; // Very light red
    borderColor = '#fecaca';
  }

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        background: bgColor,
        color: color,
        border: `1px solid ${borderColor}`,
        fontWeight: 600,
        fontSize: '8px',
        transition: 'all 0.2s ease',
        boxShadow: 'none',
        '&:hover': {
          transform: 'translateY(-1px)',
          boxShadow: `0 2px 8px ${color}15`,
        },
      }}
    >
      {numericScore.toFixed(0)}%
    </Box>
  );
};

export default ConfidenceBadge;